// extracted by mini-css-extract-plugin
export default {"control":"Settings_control__R8-9f","settings":"Settings_settings__fYbWr"};